import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Privacy from "./pages/Privacy";
import Payments from "./pages/Payments";

function App() {
  useEffect(() => {
  }, []);

  return (
    <div id="app">
      <BrowserRouter>
        <Routes>
          <Route exact path="/payments" element={<Payments />} />
          <Route exact path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
